module.exports = __webpack_public_path__ + "img/hcs-profile.854361fb.jpg";